import _regeneratorRuntime from "C:\\Users\\headl\\Documents\\GitHub\\pipeline-ui\\demo\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

import MyAlgo from '@randlabs/myalgo-connect';

var Pipeline = /*#__PURE__*/function () {
  function Pipeline() {
    _classCallCheck(this, Pipeline);
  }

  _createClass(Pipeline, null, [{
    key: "init",
    value: function init() {
      return new MyAlgo();
    }
  }, {
    key: "balance",
    value: function () {
      var _balance = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(address) {
        var indexerURL, url2, data, data2, data3;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                indexerURL = 'https://algoexplorerapi.io/idx2/v2/accounts/';
                url2 = indexerURL + address;
                _context.prev = 2;
                _context.next = 5;
                return fetch(url2);

              case 5:
                data = _context.sent;
                _context.next = 8;
                return data.json();

              case 8:
                data2 = _context.sent;
                data3 = JSON.stringify(data2.account.amount / 1000000) + ' Algos';
                return _context.abrupt("return", data3);

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](2);
                console.log(_context.t0);

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 13]]);
      }));

      function balance(_x) {
        return _balance.apply(this, arguments);
      }

      return balance;
    }()
  }, {
    key: "connect",
    value: function () {
      var _connect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(wallet) {
        var accounts, item1;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return wallet.connect();

              case 3:
                accounts = _context2.sent;
                item1 = accounts[0];
                item1 = item1['address'];
                return _context2.abrupt("return", item1);

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](0);
                console.error(_context2.t0);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 9]]);
      }));

      function connect(_x2) {
        return _connect.apply(this, arguments);
      }

      return connect;
    }()
  }, {
    key: "send",
    value: function () {
      var _send = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(address, amt, myNote, sendingAddress, wallet) {
        var index,
            algodToken,
            paramServer,
            transServer,
            buf,
            encodedNote,
            i,
            strLen,
            params,
            txn,
            signedTxn,
            transactionID,
            _args3 = arguments;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                index = _args3.length > 5 && _args3[5] !== undefined ? _args3[5] : 0;
                algodToken = '0';
                paramServer = 'https://algoexplorerapi.io/v2/transactions/params';
                transServer = 'https://algoexplorerapi.io/v2/transactions';
                buf = new Array(myNote.length);
                encodedNote = new Uint8Array(buf);

                for (i = 0, strLen = myNote.length; i < strLen; i++) {
                  encodedNote[i] = myNote.charCodeAt(i);
                }

                console.log('My encoded note: ' + encodedNote);
                _context3.prev = 8;
                _context3.next = 11;
                return fetch(paramServer);

              case 11:
                _context3.next = 13;
                return _context3.sent.json();

              case 13:
                params = _context3.sent;
                txn = {
                  from: sendingAddress,
                  to: address,
                  amount: parseInt(amt),
                  note: encodedNote,
                  genesisID: 'mainnet-v1.0',
                  genesisHash: 'wGHE2Pwdvd7S12BL5FaOP20EGYesN73ktiC1qzkkit8=',
                  type: 'pay',
                  flatFee: true,
                  fee: 1000,
                  firstRound: params['last-round'],
                  lastRound: params['last-round'] + 1000
                };

                if (index !== 0) {
                  txn.type = 'axfer';
                  txn.assetIndex = parseInt(index);
                }

                console.log(txn);
                _context3.next = 19;
                return wallet.signTransaction(txn);

              case 19:
                signedTxn = _context3.sent;
                _context3.next = 22;
                return fetch(transServer, {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/x-binary'
                  },
                  body: signedTxn.blob
                }).then(function (response) {
                  return response.json();
                }).then(function (data) {
                  return data.txId;
                })["catch"](function (error) {
                  console.error('Error:', error);
                });

              case 22:
                transactionID = _context3.sent;
                return _context3.abrupt("return", transactionID);

              case 26:
                _context3.prev = 26;
                _context3.t0 = _context3["catch"](8);
                console.error(_context3.t0);

              case 29:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[8, 26]]);
      }));

      function send(_x3, _x4, _x5, _x6, _x7) {
        return _send.apply(this, arguments);
      }

      return send;
    }()
  }]);

  return Pipeline;
}();
/* usage

var balance = 0;

Pipeline.balance(address).then(data => balance = data);

const myAlgoWallet = Pipeline.init();

Pipeline.connect(myAlgoWallet)
    .then(data => {
        console.log(data);
    });

Pipeline.send(address, amount, note, sendingAddress, myAlgowallet, index)
    .then(data => {
        console.log(data);
    });

    */


export { Pipeline as default };